import CreditCardFailure from './credit-card-failure.vue';

export default CreditCardFailure;
